// Safari on an iPhone zooms the page into a field whose text it judges under 16px when the field
// takes the cursor, and keeps that zoom after the keyboard goes, even through a reload: the page is
// cut off at the side and the tab bar sits below the screen until the list is scrolled to its end.
// 16px fields are not enough on their own, because Safari's own text size (aA, say 85%) shrinks them.
// maximum-scale=1 stops that zoom. Safari still lets people pinch to zoom whatever it says, but
// Chrome on Android would not, so it is only added on an iPhone or iPad.

/** The viewport meta's content with maximum-scale=1, unless it already has a maximum scale. */
export function withoutFocusZoom(content: string): string {
  if (/maximum-scale/.test(content)) return content
  const parts = content.split(',').map((p) => p.trim()).filter(Boolean)
  const at = parts.findIndex((p) => p.startsWith('initial-scale'))
  parts.splice(at < 0 ? parts.length : at + 1, 0, 'maximum-scale=1')
  return parts.join(', ')
}

/** Stops Safari zooming the page into a field it focuses. Call on an iPhone or iPad only. */
export function stopFocusZoom(doc: Document = document): void {
  const meta = doc.querySelector<HTMLMetaElement>('meta[name="viewport"]')
  if (meta) meta.content = withoutFocusZoom(meta.content)
}
